import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const DepositCard = ({ Card }) => {
  const { settings, setSettings } = useAuth();
  const [pct, setPct] = useState(null);
  useEffect(() => { if (settings && pct === null) setPct(settings.deposit_percent ?? 25); }, [settings]); // eslint-disable-line react-hooks/exhaustive-deps
  if (pct === null) return null;
  const save = async () => {
    try { const r = await api.put("/settings/deposit", { percent: Number(pct) }); setSettings(r.data); toast.success("Deposit setting saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title="Booking deposit" testId="settings-deposit">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center justify-between gap-4 rounded-lg border border-slate-800 bg-slate-950/40 px-4 py-2.5 w-full sm:w-80">
          <span className="text-sm">Deposit (% of tier price)</span>
          <Input data-testid="deposit-percent" type="number" min="0" max="100" value={pct} onChange={(e) => setPct(e.target.value)} className="bg-slate-950/60 border-slate-700 num w-24 h-9" />
        </div>
        <Button data-testid="deposit-save-btn" onClick={save} className="rounded-full bg-emerald-500 text-emerald-950 hover:bg-emerald-400">Save deposit</Button>
      </div>
      <p className="text-xs text-slate-500 mt-4">After a pricing request, visitors can pay this deposit by PayPal (LIVE payments). It is credited automatically on the client's next invoice. Set 0 to turn deposits off.</p>
    </Card>
  );
};
